import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Uttrakhand National Games Transport Management System{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
